import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";

const Ordergenerateinstitute = () => {
  const { numRows } = useParams();
  const location = useLocation();
  const barcodeInputRef = useRef(null);
  const selectRef = useRef(null);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [currentScanIndex, setCurrentScanIndex] = useState(0);
  const [numRowsIndex, setNumRowsIndex] = useState(1);
  const [scanHistory, setScanHistory] = useState([]);
  const shipmentData = location.state?.shipmentData || null;
  const [Data, setData] = useState([]);
  const [currentSectionCount, setCurrentSectionCount] = useState(0);
  const [quantityMatch, setQuantityMatch] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const allSKUs = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => orderDetail.SKU)
  );

  const allquantity = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => ({
      SKU: orderDetail.SKU,
      approvedquantity: orderDetail.approvedquantity,
    }))
  );

  const isScanningCompleted = currentScanIndex >= parseInt(numRows);

  const handleAddBarcode = async (barcode) => {
    if (!selectedOrderId) {
      swal({
        title: "Please Select an option",
        text: "",
        icon: "warning",
      });
      return;
    }
    const response = await Axios.get(
      `${INVENTORY_API_BASE_URL}/getKey/${barcode}`
    );
    const barcod2 = response.data.key;

    if (barcod2) {
      const matchedItem = Data.find(
        (item) => item.barcodeData?.includes(barcod2)
      );

      const containsSKU = allSKUs.some((sku) => barcod2.includes(sku));

      if (matchedItem) {
        const allScannedBarcodes = [...scannedBarcodes];
        scanHistory.forEach((scan) => {
          allScannedBarcodes.push(...scan.scannedData);
        });

        if (allScannedBarcodes.includes(barcod2)) {
          alertify.error("Barcode already scanned!");
          barcodeInputRef.current.value = "";
        } else if (!containsSKU) {
          alertify.error("Barcode does not contain any SKU!");
          barcodeInputRef.current.value = "";
        } else {
          if (currentSectionCount + 1 !== totalQuantity) {
            setQuantityMatch(false);
          } else {
            setQuantityMatch(true);
          }

          const skuInBarcode = allSKUs.find((sku) => barcod2.includes(sku));
          const skuCountInAllScannedBarcodes = allScannedBarcodes.filter((b) =>
            b.includes(skuInBarcode)
          ).length;
          const approvedQuantityForSKU = allquantity.find(
            (q) => q.SKU === skuInBarcode
          ).approvedquantity;

          if (skuCountInAllScannedBarcodes >= approvedQuantityForSKU) {
            alertify.error(
              `SKU ${skuInBarcode} has reached its approved quantity!`
            );
            barcodeInputRef.current.value = "";
            return;
          }

          setScannedBarcodes((prevBarcodes) => [...prevBarcodes, barcod2]);
          setCurrentSectionCount((prevCount) => prevCount + 1);
          barcodeInputRef.current.value = "";
          barcodeInputRef.current.focus();

          alertify.success(`Barcode Scanned: ${barcod2}`);
        }
      } else {
        alertify.error("Barcode not found!");
        barcodeInputRef.current.value = "";
      }
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setData(response.data);
      }
    );
  }, []);

  const handleNextScan = () => {
    if (!isScanningCompleted) {
      const scannedData = scannedBarcodes;
      const newScan = {
        numRows: numRowsIndex,
        scannedData,
        count: scannedBarcodes.length,
        OrderNumber: selectedOrderId,
      };
      setScanHistory((prevHistory) => [...prevHistory, newScan]);

      setCurrentScanIndex((prevIndex) => prevIndex + 1);
      setNumRowsIndex((prevIndex) => prevIndex + 1);
      setScannedBarcodes([]);
      setSelectedOrderId("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    if (isScanningCompleted) {
      alertify.success("Scanning completed!");
    }
  }, [isScanningCompleted]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const barcod1 = e.target.value;
      handleAddBarcode(barcod1);
    }
  };

  useEffect(() => {
    const clickHandler = (e) => {
      if (
        e.target !== barcodeInputRef.current &&
        e.target !== selectRef.current
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", clickHandler);

    return () => {
      document.removeEventListener("click", clickHandler);
    };
  }, []);

  const totalCount = scanHistory.reduce((total, scan) => total + scan.count, 0);

  const totalQuantity = shipmentData?.totalQuantity || 0;

  const handleCreateOutbound = async () => {
    if (!isScanningCompleted) {
      alertify(
        "Scanning is not completed. Please finish scanning before creating outbound."
      );
      return;
    }

    setIsLoading(true);
    const shipmentDataToPost = {
      totalCount: totalCount,
      totalBoxes: shipmentData.totalBoxes,
      totalWeight: shipmentData.totalWeight,
      barcodeData: scanHistory.map((scan) => ({
        BoxNo: scan.numRows,
        scannedData: scan.scannedData,
        count: scan.count,
        DistributorName: scan.DistributorName,
        OrderNum: scan.OrderNumber,
      })),
    };

    try {
      await Axios.post(
        `${INVENTORY_API_BASE_URL}/createshipmentInstitute`,
        shipmentDataToPost
      );

      for (let index = 0; index < scanHistory.length; index++) {
        const scan = scanHistory[index];
        const scannedDataToSend = scan.scannedData;

        await Axios.delete(
          `${INVENTORY_API_BASE_URL}/putawayOutbound`,
          {
            data: { barcodeData: scannedDataToSend },
          }
        );

        swal({
          title: `Barcode Data Removed for Scan ${index + 1}`,
          text: "",
          icon: "success",
        });
      }

      window.location.reload();
    } catch (error) {
      alertify("Service error");
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="generated-table-page-container">
      <h2>Create Shipment</h2>
      <select
        ref={selectRef}
        value={selectedOrderId}
        onChange={(e) => setSelectedOrderId(e.target.value)}
        disabled={isScanningCompleted}
      >
        <option value="">Select an option</option>
        {shipmentData?.ShipmentDetails?.map((detail) => (
          <option key={detail.orderId} value={detail.orderId}>
            {detail.orderId}
          </option>
        ))}
      </select>
      <h3 className="boxnumber">Box Number: {numRowsIndex}</h3>

      <h3 className="boxnumber1">Barcode Scanned: {scannedBarcodes.length} </h3>

      <input
        className="addbarcode"
        type="text"
        placeholder="Enter Barcode"
        ref={barcodeInputRef}
        onKeyDown={handleKeyDown}
        disabled={isScanningCompleted || currentSectionCount === totalQuantity}
      />
      <button
        onClick={() => handleAddBarcode(barcodeInputRef.current.value)}
        disabled={isScanningCompleted}
        className="addbtn"
      >
        Add Barcode
      </button>
      <button
        className="nextbtn"
        onClick={handleNextScan}
        disabled={isScanningCompleted}
      >
        Next
      </button>

      <div>
        <div className="scan-history-container">
          <h3>Scan History:</h3>
          <ul className="scan-list">
            {scanHistory.map((scan, index) => (
              <li className="scan-item" key={index}>
                <span className="box-number">
                  Box Number:{" "}
                  <span className="bold-numRows">{scan.numRows}</span>
                </span>
                <span className="count-label">Count for this box:</span>
                {scan.count}
              </li>
            ))}
          </ul>
        </div>

        <div className="summary-container">
          <div className="summary-item">
            <h3>Total Count:</h3>
            <p>{currentSectionCount}</p>
          </div>
          <div className="summary-item">
            <h3>Order Quantity:</h3>
            <p>{totalQuantity}</p>
          </div>
        </div>
        <h4>Scanned Barcodes:</h4>
        <ul>
          {scannedBarcodes.map((barcode, index) => (
            <li key={index}>{barcode}</li>
          ))}
        </ul>
      </div>
      {isLoading && (
        <div
          style={{ "font-size": "2rem", color: "red", marginBottom: "1rem" }}
        >
          Loading...
        </div>
      )}
      {quantityMatch && (
        <button
          onClick={handleCreateOutbound}
          className="outboundbtn"
          // enabled={isScanningCompleted}
          disabled={!isScanningCompleted}
        >
          Create Outbound
        </button>
      )}
    </div>
  );
};

export default Ordergenerateinstitute;
